import React from "react";
import HeroSection from "./HeroSection";
import EventSection from "./EventSection";
import InfoSection from "./InfoSection";
import SponsorSection from "./SponsorSection";
import header from "images/pattern/header.svg";

const HomePage = () => {
  return (
    <div
      className="min-h-screen flex flex-col px-6 md:px-16 py-16 md:py-36 
      bg-wce-pink-light gap-20 md:gap-32 w-full overflow-hidden"
    >
      <div className="absolute left-0 -top-1 w-full block">
        <img className="w-full min-w-full" src={header} alt={"header"} />
      </div>
      <HeroSection />
      <EventSection />
      <InfoSection />
      <SponsorSection />
    </div>
  );
};

export default HomePage;
